module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form__group"
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label) + ": "), (_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: {
      'is-danger': _vm.fileError || _vm.hasError
    },
    attrs: {
      "type": "file",
      "id": "uploadCaptureInputFile",
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "change": _vm.onFileSelect
    }
  }), _vm._v(" "), (_vm.fileError || _vm.hasError) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('sweet-modal', {
    ref: "cropImage",
    attrs: {
      "hide-close-button": "",
      "blocking": ""
    }
  }, [_c('div', [_c('VueCropper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedFile),
      expression: "selectedFile"
    }],
    ref: "cropper",
    attrs: {
      "viewMode": 3,
      "zoomable": false,
      "aspect-ratio": 4 / 3,
      "src": _vm.selectedFile,
      "alt": "Source Image"
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn--primary",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "id": "save-race-image"
    },
    on: {
      "click": function($event) {
        _vm.cropImage()
      }
    }
  }, [_vm._v("Save")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-570c6d6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/UploadPhoto.vue
// module id = 1821
// module chunks = 1